// React
import React, { Fragment } from "react";

// Custom UI Components
import H3Text from "@Uilib/h3Text";
import Attachment from "@Components/Common/Attachment";

// Helpers
import { handleFileChange } from "../helper";

function ViewOutgoingPaymentFooter({
  selectedPaymentOutgoing,
  MONEY,
  fileList,
  getAttachmentByIdLoading,
  updateAttachmentLoading,
  updateAttachment,
  getAttachmentById,
  setIsGetAttachment,
  setFileList,
}) {
  return (
    <Fragment>
      <div className="view-document__totals-wrapper">
        <div className="view__document-footer-left">
          {selectedPaymentOutgoing?.remarks && (
            <div className="view__document-remarks">
              <H3Text text="Remark" className="view__document-remarks-title" />
              <H3Text
                text={
                  selectedPaymentOutgoing?.remarks
                    ? selectedPaymentOutgoing?.remarks
                    : ""
                }
                className="view__document-remarks-body"
              />
            </div>
          )}
          <div style={{ marginTop: "10px", display: "flex" }}>
            <Attachment
              fileList={fileList}
              disableCase={getAttachmentByIdLoading || updateAttachmentLoading}
              labelClassName="orgFormLabel"
              inputClassName=""
              containerClassName="view__document-attachment"
              handleFileChange={(value) =>
                handleFileChange({
                  fileListData: value,
                  updateAttachment,
                  selectedPaymentOutgoing,
                  getAttachmentById,
                  setIsGetAttachment,
                  setFileList,
                })
              }
            />
            {selectedPaymentOutgoing && (
              <div className="view-document__totals">
                <div className="view-document__totals-field">
                  <H3Text
                    text="Total Payment"
                    className="view-document__totals-field-name"
                  />
                  <H3Text
                    text={MONEY(selectedPaymentOutgoing?.amount || 0)}
                    className="view-document__totals-field-value"
                  />
                </div>
                <div className="view-document__totals-field">
                  <H3Text
                    text="Used Amount"
                    className="view-document__totals-field-name"
                  />
                  <H3Text
                    text={MONEY(
                      selectedPaymentOutgoing?.amount -
                        selectedPaymentOutgoing?.unused_amount || "0"
                    )}
                    className="view-document__totals-field-value"
                  />
                </div>
                <div className="view-document__totals-field view-document__totals-field-total">
                  <H3Text
                    text="Amount in Excess"
                    className="view-document__totals-field-name"
                  />
                  <H3Text
                    text={MONEY(selectedPaymentOutgoing?.unused_amount || 0)}
                    className="view-document__totals-field-value"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ViewOutgoingPaymentFooter;
